import Request from './request'

const ClientGroups  = {
  getClientGroupList(params, callback) {
    Request.get('client-groups?' + new URLSearchParams(params).toString()).then(callback).catch(this.bad_answer)
  },
}

export default ClientGroups
